<template>
	<v-container fluid>
		<div>
			<v-card-text>
				<ChangeVerifiedAgentDataTable :headers="isSmallScreen ? smallScreenHeaders : headers"
					:items="searchData" @assign-agent="assignIncidentToAgent" @totalRowsPerPage="filterRowsPerPage"
					@pageNumber="changePage">
				</ChangeVerifiedAgentDataTable>
			</v-card-text>
		</div>
		<v-dialog v-model="isVerifiedDialogOpen" width="400px">
			<v-card rounded="lg">
				<v-card-text style="font-family: 'Roboto'; font-weight: 600">
					<div class="py-2">
						{{ $t('want_to_change_agent') }}
						<span style="color: rgba(255, 126, 135, 1)">
							{{ assigningAgent }}
						</span>
						?
					</div>
				</v-card-text>
				<v-card-foot class="bg-black">
					<div class="d-flex justify-space-between">
						<v-btn variant="text" @click="isVerifiedDialogOpen = false" class="text-none"> {{ $t('cancel')
							}}</v-btn>
						<v-btn variant="text" @click="changeAgent"> {{ $t('confirm') }}</v-btn>
					</div>
				</v-card-foot>
			</v-card>
		</v-dialog>
	</v-container>
</template>
<script>
import agentService from '@/services/API/agentService'
import settings from '@/services/API/settings'
import ChangeVerifiedAgentDataTable from './ChangeVerifiedAgentDataTable.vue'

export default {
	components: {
		ChangeVerifiedAgentDataTable,
	},

	created() {
		this.fetchAgentList()
	},

	props: {
		searchData: {
			type: Array,
			required: false
		}
	},

	data: () => ({
		agentId: '',
		selectedAgent: {},
		agentDetails: {},
		isVerifiedDialogOpen: false,
		openDispatchDialog: false,
		assignAgent: false,
		isFetchingAgents: false,
		items: '',
		headers: [
			{
				text: 'Agent Detail',
				value: 'agentDetial',
				sortable: true,
				width: '20%',
			},

			{
				text: 'Skills and Certificates',
				value: 'skills',
				width: '35%',
			},
			{
				text: '',
				value: 'assignButton',
				width: '15%',
			},
		],
	}),
	emits: ['assignIncidentToAgent'],
	methods: {
		convertStringToAscii(str) {
			return str
				.split('')
				.map((char) => char.charCodeAt(0))
				.join('')
		},
		colorGenerator(seed) {
			const hex = Math.floor(
				Math.abs(
					Math.sin(this.convertStringToAscii(seed.toLowerCase())) *
					16777215
				)
			).toString(16)
			return `#${hex}`
		},
		assignIncidentToAgent(obj) {
			this.userId = obj.id
			this.assigningAgent = obj.firstName
			this.isVerifiedDialogOpen = true
		},
		changeAgent() {
			this.$emit('assignIncidentToAgent', {
				applicationId: null,
				userId: this.userId,
			})
		},
		async fetchAgentList(pageNumber) {
			await agentService.getAllAgents(pageNumber).then((response) => {
				this.items = response.data.data
			})
		},
		async changePage(data) {
			this.fetchAgentList(data)
		},
		async filterRowsPerPage(data) {
			await settings
				.updatePageSettings(localStorage.getItem('userId'), {
					tableRowsPerPage: data,
				})
				.then((response) => {
					this.fetchAgentList()
				})

		},
	},
}
</script>
<style scoped>
.agent-profile-link {
	text-decoration: none;
	color: black;
}
</style>
